import $ from 'jquery'
// import React from 'react-dom';
// import ReactDOM from 'react-dom';
// import { convertToBoolean } from '_utils';
import config from 'store/_config'
import _, { values } from 'lodash'
import { storageAvailable, axiosInstance as axios, handleAxiosErrors, createAxiosCancellationToken } from '../_utils'
import { LS } from 'store/localStorage'
import { scrollTo } from '../dom/window'
import {
  getStartingIndex,
  isNewArrivalRequest,
  buildRequestProductListParams,
} from '../../main/selectors/defaultSelectors'
import {
  getDisplayedProducts,
  getProductsFullInfo,
  getProductsArray,
  generatePerPageInfo,
} from '../selectors/defaultSelectors'
import { convertProductsListingToAReadableFormat } from '../../dashboard/selectors/productSelectors'
import {
  requestProductHasSpecials,
  requestProductIsNewArrival,
  requestProductsNotification,
  requestProductsPrices,
  requestProductsTemplate,
  updateProductsList as updateFullProductsList,
  updateProductsScrollableList,
} from './productsActions'
import { segmentTrackProductListView, segmentTrackProductListFilter } from '../utils/segment/ecommerce'
import { setUserCredentials } from '../actions/userActions'
import { object } from 'prop-types'
import { togglePriceLoading } from './orderTemplateActions'

let cancelToken = {}

export const toggleProductsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCTS_LOADING',
      value: value,
    })
  }
}
export const toggleProductTemplateLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCTS_TEMPLATE_LOADING',
      value: value,
    })
  }
}
export const changePagination = (page) => {
  return (dispatch, getState) => {
    dispatch(changeActivePage(page + 1))
    scrollTo($('#products-list-per-page'), 10)
  }
}
export const changeSearch = (params) => {
  return (dispatch, getState) => {
    Promise.all([dispatch(updateSearchQuery(params.search))]).then(() => {
      dispatch(changeActivePage(1))
    })
  }
}
export const updateProductsPerPageList = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PRODUCTS_PER_PAGE_LIST',
      value: keyword,
    })
  }
}
export const updateSearchQuery = (keyword) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PRODUCTS_PER_PAGE_SEARCH',
      value: keyword,
    })
  }
}
export const setProductsFilters = () => {
  let productFilters = {},
    hasPreselectedFilters = false

  if (typeof window.selectedBrandFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.Brand = _.keyBy(
      window.selectedBrandFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }
  if (typeof window.selectedCountryFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.Country = _.keyBy(
      window.selectedCountryFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }
  if (typeof window.selectedRegionFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.Region = _.keyBy(
      window.selectedRegionFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }

  if (hasPreselectedFilters) {
    return (dispatch, getState) => {
      dispatch({
        type: 'SET_PRODUCTS_PER_PAGE_FILTERS',
        value: productFilters,
      })
    }
  }
}
export const setPerPage = (perPage) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PER_PAGE',
      value: perPage,
    })
  }
}
export const setSort = (sort) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_SORT',
      value: sort,
    })
  }
}
export const setPerPageFromStorage = (perPage) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage') && LS.get('perPage')) {
      dispatch(setPerPage(LS.get('perPage')))
    }
  }
}
export const setActivePage = (page) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_ACTIVE_PAGE',
      value: page,
    })
  }
}
export const setTotalPages = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_TOTAL_PAGES',
      value: value,
    })
  }
}
export const setSortBy = (sortBy, sortDirection) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_SORT_BY',
      sortBy: sortBy,
      sortDirection: sortDirection,
    })

    dispatch(requestProductsList({ startingIndex: 0 }))
  }
}
export const initializeSelectedFilters = () => {
  return (dispatch, getState) => {
    if (typeof window.brand != 'undefined') {
      dispatch(applyInitializedFilters('Brand', window.brand))
    }
    if (typeof window.country != 'undefined') {
      dispatch(applyInitializedFilters('Country', window.country))
    }
    if (typeof window.region != 'undefined') {
      dispatch(applyInitializedFilters('Region', window.region))
    }
  }
}
export const applyInitializedFilters = (type, value) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters } = state.productsPerPage
    const finalValue = decodeURI(value)

    let newFilters = {
      ...filters,
      ...{
        [type]: {
          [finalValue]: {
            id: finalValue,
            value: finalValue,
            checked: true,
          },
        },
      },
    }

    dispatch({
      type: 'SET_PRODUCTS_PER_PAGE_FILTERS',
      value: newFilters,
    })
  }
}
export const toggleActiveFilters = (flag) => {
  return {
    type: 'TOGGLE_ACTIVE_PER_PAGE_FILTERS',
    value: flag,
  }
}
export const toggleFilter = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { key, index } = params; // TODO: remove this
    const { key, id } = params
    let filters = state.productsPerPage.filters

    dispatch({
      type: 'TOGGLE_PER_PAGE_FILTER',
      value: {
        ...filters,
        [key]: {
          ...filters[key],
          [id]: {
            ...filters[key][id],
            checked: !filters[key][id].checked,
          },
          // TODO: remove this
          // [index]: {
          //     ...filters[key][index],
          //     checked: !filters[key][index].checked
          // }
        },
      },
    })
    dispatch(reloadFilters())
  }
}
export const clearFiltersByCategory = (category) => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.productsPerPage.filters
    const target = filters[category]
    Object.values(target).map((item, idnex) => {
      item.checked = false
    })

    dispatch({
      type: 'TOGGLE_PER_PAGE_FILTER',
      value: {
        ...filters,
        [category]: target,
      },
    })
    dispatch(reloadFilters())
  }
}
export const reloadFilters = () => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.productsPerPage.filters

    dispatch(setActivePage(1))
    if (checkIfThereAreFiltersActive(filters)) {
      dispatch(toggleActiveFilters(true))
    } else {
      dispatch(toggleActiveFilters(false))
    }

    dispatch(requestFilters())
    dispatch(requestProductsList({ startingIndex: 0 }))
  }
}

export const setFilterOptions = (filterOptions) => {
  return {
    type: 'SET_FILTER_OPTIONS',
    value: filterOptions,
  }
}

export const changeActivePage = (page) => {
  return (dispatch, getState) => {
    dispatch(setActivePage(page))
    dispatch(refreshCurrentView())
  }
}
export const changePerPage = (amount) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage')) {
      LS.set('perPage', amount)
    }

    dispatch(setPerPage(amount))
    dispatch(refreshCurrentView())
  }
}
export const changeSort = (sort) => {
  return (dispatch, getState) => {
    dispatch(setSort(sort))
    dispatch(refreshCurrentView())
  }
}
export const changeTableView = (tableView) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage')) {
      LS.set('tableView', tableView)
    }
    dispatch({
      type: 'SET_TABLE_VIEW',
      value: tableView,
    })
  }
}
export const refreshCurrentView = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { activePage, perPage } = state.productsPerPage

    dispatch(
      requestProductsList({
        startingIndex: getStartingIndex(perPage, activePage),
      })
    )
  }
}
const LoyaltyRangeFilters = {
  Title: 'LoyaltyPoint',
  Items:
    '[{"Title":"0_99999","Count":null},{"Title":"100000_499999","Count":null},{"Title":"500000_999999","Count":null},{"Title":"1000000_1999999","Count":null},{"Title":"2000000_10000000","Count":null}]',
  DisplayTitle: 'LoyaltyPoint',
  IsCollapsed: false,
  FilterSort: null,
}

export const requestFilters = () => {
  return (dispatch, getState) => {
    const state = getState()
    const isEvolutionRewardsPage = window.location.pathname.includes('/evolution-rewards')

    const { filters = {} } = state.productsPerPage

    const { ContainerType, Brand, Region, Country, Style, Varietal, LoyaltyPoint } = filters

    let { url, query } = config.filters.list

    let containerType = getFilterValues(ContainerType)
    let varietal = getFilterValues(Varietal)
    let style = getFilterValues(Style)
    let country = getFilterValues(Country)
    let region = getFilterValues(Region)
    let brand = getFilterValues(Brand)
    let range = getFilterValues(LoyaltyPoint)

    let params = {}

    if (window.searchKeyword !== undefined) {
      params['q'] = window.searchKeyword
    }
    if (window.categoryURL !== undefined) {
      params['CategoryURL'] = window.categoryURL
    }
    if (containerType?.length > 0) {
      params['ContainerType'] = containerType
    }
    if (varietal?.length > 0) {
      params['Varietal'] = varietal
    }
    if (style?.length > 0) {
      params['LiquorStyle'] = style
    }
    if (country?.length > 0) {
      params['Country'] = country
    }
    if (region?.length > 0) {
      params['Region'] = region
    }
    if (brand?.length > 0) {
      params['Brand'] = brand
    }
    if (isEvolutionRewardsPage && range?.length > 0) {
      params['LoyaltyPoints'] = range
    }
    if (cancelToken.productFilters) {
      cancelToken.productFilters.cancel()
    }

    cancelToken.productFilters = createAxiosCancellationToken()

    return axios
      .post(
        url,
        {
          query: query,
          variables: params,
        },
        {
          cancelToken: cancelToken.productFilters.token,
          // withCredentials: true
        }
      )
      .then((response) => {
        let modifiedFilters = response.data.data.productFilters

        if (isEvolutionRewardsPage) {
          modifiedFilters.push(LoyaltyRangeFilters)
        }
        /* 
          Convert LiquorStyle to Style before filters merging as BE is expecting LiquorStyle in params and returing 
          Style in response.
        */
        if (params['LiquorStyle']) {
          params['Style'] = params['LiquorStyle']
          delete params['LiquorStyle']
        }

        /* 
          Check if there are already filters available, then merge same filters available in old and new filters list
          and if the old filters are not available in new filters list then just set old filter count to 0 and do not 
          hide it on web. 
        */
        let newFilters = {}

        if (Object.keys(filters)?.length > 0) {
          let filterdData = convertFiltersToAReadableFormat(modifiedFilters, params, true)
          newFilters = mergeProductsFiltersData(filters, filterdData)
        } else {
          newFilters = convertFiltersToAReadableFormat(modifiedFilters, params)
        }

        dispatch({
          type: 'SET_PRODUCTS_PER_PAGE_FILTERS',
          value: newFilters,
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const buildRequestProductListUrl = (params) => {
  let { url } = config.products.listingPerPage
  let urlParams = []

  if (isNewArrivalRequest()) {
    urlParams.push('newarrivalsonly=1')
  } else {
    if (window.categoryID) {
      urlParams.push('catid=' + window.categoryID)
    }
  }

  Object.entries(params).map(([key, value]) => {
    if (typeof value != 'undefined' && value) {
      urlParams.push(`${key}=${value}`)
    }
  })

  if (urlParams.length > 0) {
    url += '&' + urlParams.join('&')
  }

  return url
}

export const requestProductsList = (params) => {
  return async (dispatch, getState) => {
    const state = getState()
    const { filters, perPage, searchKeyword, sort, filterOptions: previousFilterOptions } = state.productsPerPage
    const { ContainerType, Brand, Region, Country, Style, Type, Varietal, LoyaltyPoint } = filters
    const { startingIndex, blockID, segmentTrack, productIDs } = params
    let sendProductListFilteredTrack = false

    let { url, query } = config.products.listingPerPage
    let q = searchKeyword || window.searchKeyword
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)
    const filterOptions = {
      q,
      CategoryURL: window.categoryURL,
      limit: perPage,
      offset: startingIndex || 0,
      ContainerType: getFilterValues(ContainerType),
      Varietal: getFilterValues(Varietal),
      LiquorStyle: getFilterValues(Style),
      Country: getFilterValues(Country),
      Region: getFilterValues(Region),
      Brand: getFilterValues(Brand),
      LoyaltyPoints: getFilterValues(LoyaltyPoint),
      DisplayPrice__gte: 0,
      DisplayPrice__lte: 10000,
      BlockID: parseInt(blockID) || 0,
      Sort: sort,
      Filters: pipList,
      ProductIDs: productIDs,
    }

    if (Object.keys(previousFilterOptions).length > 0 && !_.isEqual(previousFilterOptions, filterOptions)) {
      sendProductListFilteredTrack = true
    }

    const requestProductListParams = buildRequestProductListParams(filterOptions)

    dispatch(setFilterOptions(filterOptions))

    query = query.replace(/{params}/, requestProductListParams)

    dispatch(toggleProductsLoading(true))
    dispatch(toggleProductTemplateLoading(true))
    dispatch(togglePriceLoading(true))
    if (cancelToken.searchResult) {
      cancelToken.searchResult.cancel()
    }

    cancelToken.searchResult = await createAxiosCancellationToken()

    return await axios
      .get(url, {
        params: {
          query: query,
        },
        cancelToken: cancelToken.searchResult.token,
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.searchResult.edges, state.user)
        const totalProducts = response.data.data.searchResult.pageInfo.totalCount

        // Get product IDs to request price
        const productIDs = products.map((item) => item.productID)

        Promise.all([
          dispatch(updateFullProductsList(products)),
          dispatch(updateProductsList(products, blockID, totalProducts)),
          dispatch(toggleProductsLoading(false)),
        ]).then(async () => {
          await dispatch(requestProductsPrices(productIDs, products, blockID))
          await dispatch(requestProductsTemplate(productIDs, products, blockID))
          await dispatch(requestProductsNotification(productIDs, products, blockID))
          dispatch(toggleProductTemplateLoading(false))
          const store = getState()

          const productsList = getDisplayedProducts(store.productsPerPage.list, store.products.list)
          const productsFullInfo = generatePerPageInfo(
            store.productsPerPage.list,
            getProductsFullInfo(productsList, store)
          )
          const finalProducts = getProductsArray(productsFullInfo)
          // dispatch(togglePriceLoading(false))
          if (segmentTrack?.action === 'Product List Viewed') {
            segmentTrackProductListView(window?.categoryURL, finalProducts)
            return
          }

          if (sendProductListFilteredTrack) {
            segmentTrackProductListFilter(filterOptions, finalProducts)
            return
          }
        })
      })
      .catch((error) => {
        return handleAxiosErrors(error)
      })
  }
}

export const requestProductsListLoyalty = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters, perPage, searchKeyword, sort, filterOptions: previousFilterOptions } = state.productsPerPage
    const { ContainerType, Brand, Region, Country, Style, Type, Varietal } = filters
    const { startingIndex, blockID, segmentTrack } = params
    let sendProductListFilteredTrack = false

    let { url, query } = config.products.listingPerPage
    let q = searchKeyword || window.searchKeyword
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)
    const filterOptions = {
      q,
      CategoryURL: window.categoryURL,
      limit: 8,
      offset: startingIndex || 0,
      ContainerType: getFilterValues(ContainerType),
      Varietal: getFilterValues(Varietal),
      LiquorStyle: getFilterValues(Style),
      Country: getFilterValues(Country),
      Region: getFilterValues(Region),
      Brand: getFilterValues(Brand),
      DisplayPrice__gte: 0,
      DisplayPrice__lte: 10000,
      BlockID: window.BlockID,
      Sort: sort,
      Filters: pipList,
    }

    if (Object.keys(previousFilterOptions).length > 0 && !_.isEqual(previousFilterOptions, filterOptions)) {
      sendProductListFilteredTrack = true
    }

    const requestProductListParams = buildRequestProductListParams(filterOptions)

    dispatch(setFilterOptions(filterOptions))

    query = query.replace(/{params}/, requestProductListParams)

    dispatch(toggleProductsLoading(true))
    dispatch(toggleProductTemplateLoading(true))

    if (cancelToken.searchResult) {
      cancelToken.searchResult.cancel()
    }

    cancelToken.searchResult = createAxiosCancellationToken()

    return axios
      .get(url, {
        params: {
          query: query,
        },
        //cancelToken: cancelToken.searchResult.token,
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.searchResult.edges)
        const totalProducts = response.data.data.searchResult.pageInfo.totalCount

        // Get product IDs to request price
        const productIDs = products.map((item) => item.productID)

        Promise.all([
          dispatch(updateFullProductsList(products)),
          dispatch(updateProductsList(products, blockID, totalProducts)),
          dispatch(toggleProductsLoading(false)),
        ]).then(async () => {
          await dispatch(requestProductsPrices(productIDs, products, blockID))
          await dispatch(requestProductsTemplate(productIDs, products, blockID))
          await dispatch(requestProductsNotification(productIDs, products, blockID))

          dispatch(toggleProductTemplateLoading(false))
          const store = getState()

          const productsList = getDisplayedProducts(store.productsPerPage.list, store.products.list)
          const productsFullInfo = generatePerPageInfo(
            store.productsPerPage.list,
            getProductsFullInfo(productsList, store)
          )
          const finalProducts = getProductsArray(productsFullInfo)

          if (segmentTrack?.action === 'Product List Viewed') {
            segmentTrackProductListView(window?.categoryURL, finalProducts)
            return
          }

          if (sendProductListFilteredTrack) {
            segmentTrackProductListFilter(filterOptions, finalProducts)
            return
          }
        })
      })
      .catch((error) => {
        return handleAxiosErrors(error)
      })
  }
}

export const requestSliderProductsListLoyalty = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters, perPage, searchKeyword, sort, filterOptions: previousFilterOptions } = state.productsPerPage
    const { ContainerType, Brand, Region, Country, Style, Type, Varietal } = filters
    const { startingIndex, blockID, segmentTrack } = params
    let sendProductListFilteredTrack = false

    let { url, query } = config.products.listingPerPage
    let q = searchKeyword || window.searchKeyword
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)
    const filterOptions = {
      q,
      CategoryURL: window.categoryURL,
      limit: 8,
      offset: startingIndex || 0,
      ContainerType: getFilterValues(ContainerType),
      Varietal: getFilterValues(Varietal),
      LiquorStyle: getFilterValues(Style),
      Country: getFilterValues(Country),
      Region: getFilterValues(Region),
      Brand: getFilterValues(Brand),
      DisplayPrice__gte: 0,
      DisplayPrice__lte: 10000,
      BlockID: parseInt(blockID),
      Sort: sort,
      Filters: pipList,
    }

    if (Object.keys(previousFilterOptions).length > 0 && !_.isEqual(previousFilterOptions, filterOptions)) {
      sendProductListFilteredTrack = true
    }

    const requestProductListParams = buildRequestProductListParams(filterOptions)

    dispatch(setFilterOptions(filterOptions))

    query = query.replace(/{params}/, requestProductListParams)

    dispatch(toggleProductsLoading(true))
    dispatch(toggleProductTemplateLoading(true))

    if (cancelToken.searchResult) {
      cancelToken.searchResult.cancel()
    }

    cancelToken.searchResult = createAxiosCancellationToken()

    return axios
      .get(url, {
        params: {
          query: query,
        },
        //cancelToken: cancelToken.searchResult.token,
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.searchResult.edges)
        const totalProducts = response.data.data.searchResult.pageInfo.totalCount

        // Get product IDs to request price
        const productIDs = products.map((item) => item.productID)

        Promise.all([
          dispatch(updateFullProductsList(products)),
          dispatch(updateProductsList(products, blockID, totalProducts)),
          dispatch(toggleProductsLoading(false)),
        ]).then(async () => {
          await dispatch(requestProductsPrices(productIDs, products, blockID))
          await dispatch(requestProductsTemplate(productIDs, products, blockID))
          await dispatch(requestProductsNotification(productIDs, products, blockID))

          dispatch(toggleProductTemplateLoading(false))
          const store = getState()

          const productsList = getDisplayedProducts(store.productsPerPage.list, store.products.list)
          const productsFullInfo = generatePerPageInfo(
            store.productsPerPage.list,
            getProductsFullInfo(productsList, store)
          )
          const finalProducts = getProductsArray(productsFullInfo)

          if (segmentTrack?.action === 'Product List Viewed') {
            segmentTrackProductListView(window?.categoryURL, finalProducts)
            return
          }

          if (sendProductListFilteredTrack) {
            segmentTrackProductListFilter(filterOptions, finalProducts)
            return
          }
        })
      })
      .catch((error) => {
        return handleAxiosErrors(error)
      })
  }
}

export const requestFilteredPromoDealsProducts = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters, perPage, searchKeyword, sort, filterOptions: previousFilterOptions } = state.productsPerPage
    const { ContainerType, Brand, Region, Country, Style, Type, Varietal } = filters
    const { startingIndex, blockID, segmentTrack } = params
    let sendProductListFilteredTrack = false
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)

    let { url, query } = config.products.listingPerPage
    let q = searchKeyword || window.searchKeyword

    const filterOptions = {
      q,
      CategoryURL: window.categoryURL,
      limit: perPage,
      offset: startingIndex || 0,
      ContainerType: getFilterValues(ContainerType),
      Varietal: getFilterValues(Varietal),
      LiquorStyle: getFilterValues(Style),
      Country: getFilterValues(Country),
      Region: getFilterValues(Region),
      Brand: getFilterValues(Brand),
      DisplayPrice__gte: 0,
      DisplayPrice__lte: 10000,
      BlockID: parseInt(blockID) || 0,
      Sort: sort,
      Filters: pipList,
    }

    if (Object.keys(previousFilterOptions).length > 0 && !_.isEqual(previousFilterOptions, filterOptions)) {
      sendProductListFilteredTrack = true
    }

    const requestProductListParams = buildRequestProductListParams(filterOptions)

    dispatch(setFilterOptions(filterOptions))

    query = query.replace(/{params}/, requestProductListParams)

    dispatch(toggleProductsLoading(true))
    dispatch(toggleProductTemplateLoading(true))

    if (cancelToken.searchResult) {
      cancelToken.searchResult.cancel()
    }

    cancelToken.searchResult = createAxiosCancellationToken()

    return axios
      .get(url, {
        params: {
          query: query,
        },
        //cancelToken: cancelToken.searchResult.token,
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.searchResult.edges)
        const totalProducts = response.data.data.searchResult.pageInfo.totalCount

        // Get product IDs to request price
        const productIDs = products.map((item) => item.productID)

        Promise.all([
          dispatch(updateFullProductsList(products)),
          dispatch(updateProductsList(products, blockID, totalProducts)),
          dispatch(toggleProductsLoading(false)),
        ]).then(async () => {
          await dispatch(requestProductsPrices(productIDs, products, blockID))
          await dispatch(requestProductsTemplate(productIDs, products, blockID))
          await dispatch(requestProductsNotification(productIDs, products, blockID))

          dispatch(toggleProductTemplateLoading(false))
          const store = getState()

          const productsList = getDisplayedProducts(store.productsPerPage.list, store.products.list)
          const productsFullInfo = generatePerPageInfo(
            store.productsPerPage.list,
            getProductsFullInfo(productsList, store)
          )
          const finalProducts = getProductsArray(productsFullInfo)

          if (segmentTrack?.action === 'Product List Viewed') {
            segmentTrackProductListView(window?.categoryURL, finalProducts)
            return
          }

          if (sendProductListFilteredTrack) {
            segmentTrackProductListFilter(filterOptions, finalProducts)
            return
          }
        })
      })
      .catch((error) => {
        return handleAxiosErrors(error)
      })
  }
}

export const updateProductsList = (productsList, blockID, totalProducts) => {
  return (dispatch, getState) => {
    const state = getState()
    const { perPage } = state.productsPerPage

    const newList = productsList.map((item, index) => {
      return item.id
    })

    if (blockID) {
      dispatch(setProductsScrollableListPerPage(newList, blockID))
    } else {
      dispatch(setProductsList(newList))
    }

    dispatch(setTotalPages(Math.ceil(totalProducts / perPage)))
  }
}

export const setProductsScrollableListPerPage = (list, blockID) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SCROLLABLE_LIST_PER_PAGE',
      list: list,
      blockID: blockID,
    })
  }
}

export const setProductsList = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_PER_PAGE_LIST',
      list: list,
    })
  }
}
export const getFilterValues = (list, key = 'value', callback) => {
  if (typeof list == 'undefined' || list == null) {
    return []
  }

  const newList = Object.values(list).reduce((values, item) => {
    // if (values.length > 0) return values; // TODO: remove this
    if (item.checked) {
      let pushedValue = item[key]

      // values.push(item.value);
      if (typeof callback != 'undefined' && callback) {
        pushedValue = callback(pushedValue)
      }

      values.push(pushedValue)
    }
    return values
  }, [])

  // return newList.length ? newList.toString().replace(/\s+/g, '_') : '+'; // TODO: remove this
  // return newList.length ? newList.toString().replace(/,/g, '+') : 0;
  return newList
}
export const onFetchData = (tableState, tableInstance) => {
  return (dispatch, getState) => {
    const { sortBy, sortDirection } = getState().productsPerPage
    const { sorted } = tableState

    if (sorted.length) {
      let newSortBy = sorted[0].id
      const newSortDirection = sorted[0].desc ? 'DESC' : 'ASC'

      // update the value
      if (newSortBy == 'title') {
        newSortBy = 'SortableTitle'
      }

      if (sortBy != newSortBy || sortDirection != newSortDirection) {
        dispatch(setSortBy(newSortBy, newSortDirection))
      }
    }
  }
}
export const checkIfThereAreFiltersActive = (filters) => {
  let checked = false
  Object.values(filters).map((item, index) => {
    Object.values(item).map((item, index) => {
      if (item.checked) checked = true
    })
  })
  return checked
}

export const convertToLoyaltyPointRange = (value) => {
  switch (value) {
    case '0_99999':
      return '0 – 99,999'
    case '100000_499999':
      return '100,000 – 499,999'
    case '500000_999999':
      return '500,000 – 999,999'
    case '1000000_1999999':
      return '1,000,000 – 1,999,999'
    case '2000000_10000000':
      return '2,000,000 +'
    default:
      return null
  }
}
/* 
  Added keyByTitle parameter for handling the case when we are merging the old and new filters 
  in mergeProductsFiltersData function
*/
export const convertFiltersToAReadableFormat = (list, activeFilers = {}, keyByTitle = false) => {
  let filters = {}
  const items = list
  // const data = JSON.parse(JSON.stringify(items))
  // console.log(JSON.parse(JSON.parse()))
  console.log('filters')
  const filterValues = Object.values(JSON.parse(JSON.stringify(list)))
  filterValues.forEach((filterGroup) => {
    const { FilterSort, IsCollapsed, Title, DisplayTitle, Items } = filterGroup
    if (filters[Title] === undefined) {
      filters[Title] = {}
    }
    Object.entries(JSON.parse(Items)).map(([filterItem, filterValue]) => {
      if (filterValue.Title) {
        let key = keyByTitle ? filterValue.Title : filterItem
        filters[Title][key] = {
          id: filterItem,
          value: filterValue.Title,
          title: DisplayTitle === 'LoyaltyPoint' ? convertToLoyaltyPointRange(filterValue.Title) : filterValue.Title,
          displayTitle: DisplayTitle,
          count: filterValue.Count,
          isCollapse: IsCollapsed,
          sortBy: FilterSort,
          checked: activeFilers[Title] && activeFilers[Title]?.includes(filterValue?.Title) ? true : false,
        }
      }
    })
  })

  return filters
}

/* 
  mergeProductsFiltersData function to handle merging of current and new filters 
*/
export const mergeProductsFiltersData = (currFilters, newFilters) => {
  const mergedData = {}

  Object.keys(currFilters).forEach((filter) => {
    mergedData[filter] = {}

    Object.values(currFilters[filter]).forEach((item) => {
      if (item.title) {
        const newItem = newFilters[filter][item.title]
          ? { ...newFilters[filter][item.title], id: item.id }
          : { ...item, id: item.id, count: 0 }
        mergedData[filter][item.id] = newItem
      }
    })
  })

  return mergedData
}
